"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DraftShifts = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const NewShift_1 = require("./NewShift");
const constants_1 = require("../../../../constants");
const elements_1 = require("../../../../elements");
const Button = (0, styled_1.default)(elements_1.Clickable) `
  border-radius: ${constants_1.theme.border.radius.normal}px;
  width: 100%;
  min-height: 22px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'all')};

  svg {
    color: ${constants_1.Color.TRANSPARENT};
  }

  :hover {
    background: ${constants_1.Color.LIGHTEST_BLUE};
    opacity: 50%;
    svg {
      color: ${constants_1.Color.BLACK};
      opacity: 0.65;
    }
  }
`;
const DraftShifts = (props) => {
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [props.onClickNewShift && ((0, jsx_runtime_1.jsx)(Button, { onClick: props.onClickNewShift, children: (0, jsx_runtime_1.jsx)(elements_1.Icon, { name: "PlusIcon", size: "md" }) })), props.shifts.map((shift, i) => ((0, jsx_runtime_1.jsx)(NewShift_1.NewShift, { shiftIds: [shift.id], shift: shift, onDelete: () => props.onDeleteDraftShift(shift.id), onClick: props.onClickShift
                    ? () => props.onClickShift?.(shift.id)
                    : undefined, status: "DRAFT", unselectable: true }, i)))] }));
};
exports.DraftShifts = DraftShifts;
